import React from 'react'

const PostDetails = () => {

    console.log("post Details")
  return (
    <div>PostDetails</div>
  )
}

export default PostDetails